
import { ApiService } from '..';

export const StandGuidanceService = {
    get() {
        return ApiService.get('getAllStandGuidances', null, false);
    },

    getBookedStandGuidance() {
        return ApiService.get('getBookedStandGuidance');
    },

    book(data) {
        return ApiService.postBase(data);
    },

    cancel(data) {
        return ApiService.postBase(data);
    },
};